// PlexiSystem Frontend v4.0.0 - Crystal Clear Design System
// Main App Component - Simplified and Modular
import './utils/force-rebuild';
import './utils/supabase-fix'; // Fix dla nazw tabel Supabase
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { OfferProvider } from './context/OfferContext';
import { UserProvider } from './context/UserContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppRoutes } from './routes/AppRoutes';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import './utils/debugAuth';

// Main App Component
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <UserProvider>
              <OfferProvider>
                <ToastProvider>
                  <AppRoutes />
                  <PWAInstallPrompt />
                </ToastProvider>
              </OfferProvider>
            </UserProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
